<template>
  <!-- Right aligned nav items -->
  <b-navbar-nav
    class="nav-pills nav-justified flex-column flex-sm-row project-navigation"
    id="myTab"
    role="tablist">
    <li class="nav-item header-item">
      <!-- eslint-disable-next-line max-len -->
      <router-link :to="{ name: 'project', params: { project_id: $route.params.project_id }}"
        class="nav-link p-1"
        :class="{ 'project-navigation-item': isDesktop }"
        id="summary-tab"
        aria-controls="summary"
        exact>
        Summary
      </router-link>
    </li>
    <li class="nav-item header-item">
      <!-- eslint-disable-next-line max-len -->
      <router-link :to= "{ name:'projectInstruments', params: { project_id: $route.params.project_id }}"
        class="nav-link p-1"
        :class="{ 'project-navigation-item': isDesktop }"
        id="instruments-tab"
        aria-controls="instruments">
        Instruments
      </router-link>
    </li>
    <li class="nav-item header-item">
      <!-- eslint-disable-next-line max-len -->
      <router-link :to="{ name: 'projectProperties', params: { project_id: $route.params.project_id }}"
        class="nav-link p-1"
        :class="{ 'project-navigation-item': isDesktop }"
        id="properties-tab"
        aria-controls="properties">
        Properties
      </router-link>
    </li>
    <li class="nav-item header-item">
      <!-- eslint-disable-next-line max-len -->
      <router-link :to= "{ name: 'projectServices', params: { project_id: $route.params.project_id }}"
        class="nav-link p-1"
        :class="{ 'project-navigation-item': isDesktop }"
        id="services-tab"
        aria-controls="services">
        Services
      </router-link>
    </li>
  </b-navbar-nav>
</template>
<script>
export default {
  name: 'ProjectNavigation',
  props: {
    isDesktop: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
